import { createAsyncThunk } from '@reduxjs/toolkit';
import { PriceApi } from '../../api/PriceApi';
import { PriceListMapApi } from '../../api/PriceListMapApi';

//Price thunk
//To get the paginated price data
export const getPrice = createAsyncThunk(
  'price/getPrice',
  async (action: { page: number; limit: number; searchCode?: string }, thunkAPI) => {
    action.materialCode = action.searchCode;
    return PriceApi.getPrice(action, thunkAPI.dispatch);
  }
);

//To delete price
export const deletePrice = createAsyncThunk('price/deletePrices', async (_action, thunkAPI) => {
  return PriceApi.deletePrices(thunkAPI.dispatch);
});

//PricelistMap thunks
//To get paginated price list map data
export const getPriceListMap = createAsyncThunk(
  'price/getPriceListMap',
  async (action: { page: number; limit: number; searchCode?: string }, thunkAPI) => {
    return PriceListMapApi.getPriceListMap(action, thunkAPI.dispatch);
  }
);

//To get a price list map details
export const getPriceListMapDetails = createAsyncThunk(
  'price/getPriceListMapDetails',
  async (action: { searchCode: string }, thunkAPI) => {
    return PriceListMapApi.getPriceListMapDetails(action, thunkAPI.dispatch);
  }
);

//To update price list map
export const updatePriceListMap = createAsyncThunk(
  'price/updatePriceListMap',
  async (action: { request }, thunkAPI) => {
    return PriceListMapApi.updatePriceListMap(action, thunkAPI.dispatch);
  }
);
